// src/pages/dashboard/DashboardSettings.jsx
import React from 'react';

const DashboardSettings = () => {
  return (
    <div className="bg-[#0B3A32] p-6 rounded-xl shadow-lg max-w-xl">
      <h2 className="text-xl font-semibold text-[#CE9242] mb-4">⚙️ Settings</h2>

      <form className="space-y-4 text-sm text-gray-200">
        <div>
          <label className="block mb-1 text-gray-400">Trading Mode</label>
          <select className="w-full bg-[#062925] p-2 rounded-md text-white border border-[#1a4c46]">
            <option>DCA</option>
            <option>Grid</option>
            <option>Manual</option>
          </select>
        </div>

        <div>
          <label className="block mb-1 text-gray-400">Notification Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            className="w-full bg-[#062925] p-2 rounded-md text-white border border-[#1a4c46]"
          />
        </div>

        <div>
          <label className="block mb-1 text-gray-400">Auto Withdraw</label>
          <input
            type="checkbox"
            className="mr-2 align-middle"
          />
          Enable daily profit auto-withdrawal
        </div>

        <button
          type="submit"
          className="mt-4 px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-md"
        >
          Save Settings
        </button>
      </form>
    </div>
  );
};

export default DashboardSettings;
